<template>
  <div class="profile-img ml-0 ml-lg-2 d-flex flex-row justify-content-start align-items-center py-2">
  <b-nav-item-dropdown variant="transparent" right class="mr-0 mr-lg-3">
    <template slot="button-content" class="ef-dark m-0 p-0">
      <img src="@/module_b2b_users/assets/images/default-profile.jpg" class="rounded mx-0 mx-lg-2" width="30px"
           height="30px" />
      <span
        class="font-size-16 line-height-24 font-weight-bold d-none d-lg-inline-block notranslate">{{ getUserName }}</span>
    </template>
    <b-dropdown-item v-if="isAdminPage" to="/user/main">{{ t('Home') }}</b-dropdown-item>
    <b-dropdown-item v-if="isCorporateAdmin && showCorpItems && !isAdminPage" :to="'/management'">{{ t('Admin Panel') }}</b-dropdown-item>
    <b-dropdown-item v-if="isAdmin" @click="goToAdminProfile">{{ t('Admin Profile') }}</b-dropdown-item>
    <b-dropdown-item :to="'/edit-profile'">{{ t('Edit Profile') }}</b-dropdown-item>
    <b-dropdown-item v-if="showTransactions" :to="'/user/billing'">{{ t('Billing') }}</b-dropdown-item>
    <b-dropdown-item :to="'/workoutIntro'" v-if="!isPhysiotherapy">{{ t('Guide') }}</b-dropdown-item>
    <b-dropdown-item :href="'https://help.elitefitforyou.com/'" target="_blank">{{ t('Help Center') }}</b-dropdown-item>
    <b-dropdown-item @click="goToSupportForm">{{ t('Support Ticket') }}</b-dropdown-item>
    <b-dropdown-item @click="signOut()">{{ t('Logout') }}</b-dropdown-item>
  </b-nav-item-dropdown>
</div>

</template>
<script>
import api from "@/module_b2b_users/api/api";
import { i18nComponentMixin } from '@/i18n/mixin';
import {createNamespacedHelpers} from "vuex";
const {
  mapState: challengesState,
} = createNamespacedHelpers("b2bUser/challenges");

export default {
mixins:[i18nComponentMixin('components/EfFooter')],
data() {
    return {
      showCorpItems: true
    }
  },
  props:{
    isAdminPage : {
      type : Boolean, 
      default : false
    }
  },
  computed: {
    ...challengesState(["tenantData"]),
    userInfo() {
      return this.$store.state.userInfo || {}
    },
    showTransactions() {
      return !!this.userInfo?.corporate?.config?.showTransactionHistory;
    },
    isCorporateAdmin() {
      return this.userInfo.role === 'CorporateHR';
    },
    isAdmin() {
      return this.userInfo.role && this.userInfo.privileges.includes('access-admin-screen')
    },
    isPhysiotherapy() {
      return this.userInfo.corporate?.theme === "physiotherapy";
    },
    getUserName() {
      let displayName = this.userInfo.name;
      if (displayName && displayName.trim().length > 0) {
        return displayName.trim();
      } else if (this.userInfo.email) {
        return this.userInfo.email.split("@")[0];
      } else {
        return "-";
      }
    },
  },
  methods: {
    goToAdminProfile() {
      this.$router.push("/admin/dashboard");
    },
    goToSupportForm() {
      window.open("https://forms.monday.com/forms/20e51e1050e0269083a0749fa3cde559?r=use1", '_blank');
    },
    signOut() {
      this.$store.dispatch("logout");
    },
  },
  async mounted() {
    const tenantId = this.userInfo?.corporate?.tenant_id;
    if (tenantId) {
      const corporateUserAccessResp = await api.verifyUser({
        tenant_id: tenantId
      });

      if (corporateUserAccessResp.code != 200) this.showCorpItems = false;
    }
  }
}
</script>
<style lang="scss" scoped>
.profile-img {
  width: wrap !important;
  height: wrap !important;
  max-width: 100%;
  max-height: 70%;
  box-shadow: 0px 16px 49px rgba(20, 21, 19, 0.15);
  border-radius: 100px;
  background-color: #f9f9f9;
}

.nav-item {
  list-style-type: none;

  ::v-deep .nav-link {
    outline: none;
  }
}

// Mobile Landscape
@media (max-width: 768px) {
  .profile-img {
    background-color: none;
    box-shadow: none !important;
  }

  .nav-item b {
    font-size: 14px !important;
  }
}
// Mobile Portrait
@media screen and (max-width: 480px) {
  .nav-item b {
    font-size: 14px !important;
  }
}
// Very small mobile screen
@media screen and (max-width: 330px) {
  .nav-item b {
    font-size: 12px !important;
  }
}
</style>
